import script from "./BaseOutput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseOutput.vue?vue&type=script&setup=true&lang=js"

import "./BaseOutput.vue?vue&type=style&index=0&id=ca9e2e34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca9e2e34"]])

export default __exports__